export const ROUTES = {
	VERIFY: 'verify-identity',
	VERIFIDATA: 'verification-data',
	EMPLOYMENT: 'employment-and-address',
	FINANCIAL: 'financial-data',
	DOCUMENTS: 'loading-documents',
	FINISHED: 'costumer-finished',
};
